import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AlertContext from "../../Context/Alert/AlertContext";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { BaseURL } from "../../Files/BaseURL";
import { formatDateForInput } from "../../Files/UseFunction";
import { FaCamera } from "react-icons/fa";
import ThemeContext from "../../Context/theme/ThemeContext";

function EditProfile({ setProfileModel, ProfileModel, fetchUser }) {
  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);
  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dob, setDob] = useState("");
  const [streetAddress, setStreetAddress] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [phone, setPhone] = useState("");
  const [CountryList, setCountryList] = useState([]);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [profilePhotoURL, setProfilePhotoURL] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(`${BaseURL}/api/user/profileData`, {
        headers: {
          "auth-token": authToken,
        },
      });
      const user = response.data;
      setFirstName(user.FirstName);
      setLastName(user.LastName);
      setDob(formatDateForInput(user.DOB));
      setStreetAddress(user.Homeaddress.Address);
      setCity(user.Homeaddress.City);
      setCountry(user.Homeaddress.Country);
      setState(user.Homeaddress.State);
      setZipCode(user.Homeaddress.Zip);
      setPhone(user.Phone);
      setProfilePhotoURL(user.ProfilePhoto);
    } catch (error) {
      showAlert("Error fetching profile data", "danger");
    }
  };

  useEffect(() => {
    fetchData();
  }, [ProfileModel]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const authToken = localStorage.getItem("p@token");
      const formData = new FormData();
      formData.append("FirstName", firstName);
      formData.append("LastName", lastName);
      formData.append("DOB", dob);
      formData.append("Phone", phone);
      formData.append("Homeaddress[Address]", streetAddress);
      formData.append("Homeaddress[City]", city);
      formData.append("Homeaddress[Country]", country);
      formData.append("Homeaddress[State]", state);
      formData.append("Homeaddress[Zip]", zipCode);
      if (profilePhoto) {
        formData.append("profimg", profilePhoto);
      }

      const response = await axios.put(
        `${BaseURL}/api/user/UpdateProfile`,
        formData,
        {
          headers: {
            "auth-token": authToken,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      showAlert("Profile updated successfully", "success");
      setProfileModel(false);
      fetchUser();
    } catch (error) {
      showAlert("Error updating profile", "danger");
      setLoading(false);
    }
  };

  const handlePhotoChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setProfilePhoto(e.target.files[0]);
      setProfilePhotoURL(URL.createObjectURL(e.target.files[0]));
    }
  };

  const fetchCountry = async () => {
    try {
      const response = await fetch(`${BaseURL}/api/auth/getcountry`);
      const data = await response.json();
      setCountryList(data.Country);
    } catch (error) {
      showAlert(error.message, "danger");
    }
  };

  useEffect(() => {
    fetchCountry();
  }, []);

  return (
    <>
      {ProfileModel && (
        <div className="fixed top-0 left-0 w-screen h-screen z-40 flex justify-center items-center">
          <div
            className="absolute bg-black/50 w-screen h-screen z-30"
            onClick={() => {
              setProfileModel(false);
            }}
          ></div>
          <div
            className={`mx-6  p-8 rounded-lg shadow-md z-40 max-h-[90vh] overflow-y-scroll overflow-x-hidden *:         ${
              theme == "dark" ? "bg-black text-white" : "bg-white "
            }`}
          >
            <h2 className="text-2xl font-pop font-bold mb-4">Edit Profile</h2>
            <p
              className={` text-gray-600 font-pop mb-6 max-w-sm           ${
                theme == "dark" && " text-white"
              }`}
            >
              Personal information
            </p>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <div className="relative self-center w-fit">
                  <label htmlFor="fileupload">
                    {profilePhotoURL ? (
                      <div className="w-28 h-28 rounded-full overflow-hidden">
                        <img
                          src={profilePhotoURL}
                          alt=""
                          className="w-full h-full object-cover rounded-full"
                        />
                      </div>
                    ) : (
                      <div className="w-28 h-28 rounded-full font-pop bg-gray-400 text-2xl flex items-center justify-center">
                        <span className="text-white">
                          {firstName.charAt(0)}
                        </span>
                      </div>
                    )}
                    <div className="absolute bottom-2 bg-primarygreen p-2 rounded-full z-10 right-0">
                      <FaCamera className="text-white cursor-pointer" />
                      <input
                        type="file"
                        name="fileupload"
                        id="fileupload"
                        className="opacity-0 absolute"
                        onChange={handlePhotoChange}
                      />
                    </div>
                  </label>
                </div>
              </div>
              <div className="mb-4">
                <input
                  type="text"
                  id="first-name"
                  name="first-name"
                  placeholder="First Name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  className={`w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none           ${
                    theme == "dark"
                      ? "bg-black text-white border-white"
                      : "bg-white "
                  }`}
                />
              </div>
              <div className="mb-4">
                <input
                  type="text"
                  id="last-name"
                  name="last-name"
                  placeholder="Last Name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  className={`w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none           ${
                    theme == "dark"
                      ? "bg-black text-white border-white"
                      : "bg-white "
                  }`}
                />
              </div>
              <div className="mb-4">
                <input
                  type="date"
                  id="dob"
                  name="dob"
                  placeholder="Date of Birth"
                  value={dob}
                  onChange={(e) => setDob(e.target.value)}
                  className={`w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none           ${
                    theme == "dark"
                      ? "bg-black text-white border-white "
                      : "bg-white "
                  }`}
                />
              </div>
              <div className="w-[100%] h-[2px] bg-gray-200"></div>
              <p
                className={` text-gray-600 font-pop mb-4 max-w-sm mt-4 ${
                  theme === "dark" && "text-white"
                }`}
              >
                Home address
              </p>
              <div className="mb-4">
                <input
                  type="text"
                  id="street-address"
                  name="street-address"
                  placeholder="Street address"
                  value={streetAddress}
                  onChange={(e) => setStreetAddress(e.target.value)}
                  className={`w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none           ${
                    theme == "dark"
                      ? "bg-black text-white border-white"
                      : "bg-white "
                  }`}
                />
              </div>
              <div className="mb-4">
                <input
                  type="text"
                  id="city"
                  name="city"
                  placeholder="City"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  className={`w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none           ${
                    theme == "dark"
                      ? "bg-black text-white border-white"
                      : "bg-white "
                  }`}
                />
              </div>
              <div className="mb-4">
                <select
                  name="country"
                  id="country"
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  className={`w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none           ${
                    theme == "dark"
                      ? "bg-black text-white border-white "
                      : "bg-white "
                  }`}
                >
                  <option value="">Select Country</option>
                  {CountryList.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-4 flex justify-between gap-2">
                <input
                  name="state"
                  id="state"
                  value={state}
                  placeholder="State"
                  onChange={(e) => setState(e.target.value)}
                  className={`w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none           ${
                    theme == "dark"
                      ? "bg-black text-white border-white "
                      : "bg-white "
                  }`}
                />
                <input
                  type="number"
                  id="zip-code"
                  name="zip-code"
                  placeholder="Zip Code"
                  value={zipCode}
                  onChange={(e) => setZipCode(e.target.value)}
                  className={`w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none           ${
                    theme == "dark"
                      ? "bg-black text-white border-white"
                      : "bg-white "
                  }`}
                />
              </div>

              <p
                className={` text-gray-600 font-pop mb-4 max-w-sm mt-4 ${
                  theme == "dark" && " text-white "
                }`}
              >
                Contact information
              </p>
              <div className="mb-4">
                <PhoneInput
                  name="phoneNumber"
                  type="text"
                  country={"us"}
                  enableAreaCodes={true}
                  areaCodes={{ us: ["332"] }}
                  inputProps={{
                    name: "phone",
                    country: "us",
                    required: true,
                    autoFocus: true,
                  }}
                  containerClass="rounded-full"
                  className={`rounded-full`}
                  inputClass="w-full px-6 border-2 border-transparent font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-green-500 focus:outline-none"
                  buttonStyle={{
                    borderTopLeftRadius: "9999px",
                    borderBottomLeftRadius: "9999px",
                  }}
                  inputStyle={{
                    width: "100%",
                    borderRadius: "9999px",
                  }}
                  value={phone}
                  onChange={(phone) => setPhone(phone)}
                  required
                />
              </div>
              <button
                type="submit"
                className={`my-4 w-full bg-green-500 hover:bg-transparent hover:bg-white-500 font-semibold  font-pop text-xl py-3 px-4 border border-black-500 hover:border-green-500 rounded-full text-white animate__animated animate__backInUp
                                ${
                                  theme === "dark"
                                    ? "hover: text-white"
                                    : "hover:text-black"
                                }`}
              >
                {loading ? "updating" : "Update"}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default EditProfile;
